
export const all_routes = {
  // Home
  home1: "/index",

  // Auth
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  changepassword: "/change-password",

  // Bot
  triobot: "/chatbot",

  // Flight
  flightGrid: "/flight/flight-grid",
  flightList: "/flight/flight-list",
  flightDetails: "/flight/flight-details",
  flightAmenities: "/flight/flight-amenities",
  flightBooking: "/flight/flight-booking",
  flightBookingConfirmation: "/flight/flight-booking-confirmation",
  flightHoldConfirmation: "/flight/hold-confirmation",

  // Hotel
  hotelGrid: "/hotel/hotel-grid",
  hotelList: "/hotel/hotel-list",
  hotelMap: "/hotel/hotel-map",
  hotelDetails: "/hotel/hotel-details",
  hotelBooking: "/hotel/hotel-booking",
  hotelBookingConfirmation: "/hotel/hotel-booking-confirmation",
  hotelGuestDetails: "/hotel/hotel-guest-details",

  // User dashboard
  userDashboard: "/user/dashboard",
  payment: "/user/payment",
  userFlightBooking: "/user/customer-flight-booking",
  userHotlesBooking: "/user/customer-hotel-booking",
  userReviews: "/user/review",
  userChat: "/user/chat",
  userWishlist: "/user/wishlist",
  userWallet: "/user/wallet",
  myProfile: "/user/my-profile",
  profileSettings: "/user/profile-settings",
  notification: "/user/notifications",
  securitySettings: "/user/security-settings",
  notificationSettings: "/user/notification-settings",
  integrationSettings: "/user/integration-settings",

  // Static pages
  privacyPolicy: "/pages/privacy-policy",
  termsConditions: "/terms-conditions",
  contactUs: "pages/contact-us",
  about_us: "/pages/about-us",
  invoices: "/pages/invoices",
  FAQ: "/pages/faq",
  Error404: "/pages/error-404",
  Error500: "/pages/error-500",

  // Admin
  admin: "/admin/dashboard",

  // Legacy stubs — referenced in kept UI components; pages are removed but Links still compile
  userProfileSettings: "/user/profile-settings",
  teams: "/pages/about-us",
  Gallery: "/pages/about-us",
  blogGrid: "/index",
  tourDetails: "/index",
  tourGrid: "/index",
  addHotel: "/index",
  carGrid: "/index",
  carDetails: "/index",
  cruiseGrid: "/index",
  cruiseDetails: "/index",
};
